/**
 * PanelHeaderAction — the ONE style for actions in a WorkspacePanel header
 * (and the command-column cards): icon + short label, text-button weight.
 * `primary` (blue) for the panel's main action (Add, Import, New Idea),
 * `secondary` (gray) for supporting ones (Generate, All ideas).
 */

import React, { ReactNode } from "react";

interface PanelHeaderActionProps {
  label: string;
  icon?: ReactNode;
  onClick: () => void;
  variant?: "primary" | "secondary";
  disabled?: boolean;
  /** Accessible name override when the label alone is ambiguous. */
  ariaLabel?: string;
}

const VARIANT_CLASSES: Record<string, string> = {
  primary: "text-blue-600 hover:text-blue-700",
  secondary: "text-gray-600 hover:text-gray-800",
};

export const PanelHeaderAction: React.FC<PanelHeaderActionProps> = ({
  label,
  icon,
  onClick,
  variant = "primary",
  disabled = false,
  ariaLabel,
}) => (
  <button
    type="button"
    onClick={onClick}
    disabled={disabled}
    aria-label={ariaLabel}
    className={`inline-flex items-center gap-1 text-sm font-medium transition-colors disabled:opacity-50 ${VARIANT_CLASSES[variant]}`}
  >
    {icon}
    {label}
  </button>
);
